'use client';
import { useState, useRef, useEffect } from 'react';
import { useCurrency } from '@/lib/currency/CurrencyContext';

export default function CurrencySwitcher() {
  const { currency, setCurrency, activeCurrencies } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on click outside
  useEffect(() => {
    if (!open) return;
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  if (activeCurrencies.length <= 1) return null;

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center justify-center h-10 px-2.5 rounded-lg text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-subtle/50 transition-colors"
        aria-label="Select currency"
      >
        <span className="text-[11px] font-semibold tabular-nums">
          {currency.symbol} {currency.code}
        </span>
      </button>
      {open && (
        <div className="absolute end-0 top-full mt-1 bg-background border border-border rounded-lg shadow-lg z-30 min-w-[100px]">
          {activeCurrencies.map((c) => (
            <button
              key={c.code}
              onClick={() => { setCurrency(c); setOpen(false); }}
              className={`w-full text-start px-3 py-2 text-sm hover:bg-subtle/50 transition-colors first:rounded-t-lg last:rounded-b-lg ${
                c.code === currency.code ? 'bg-subtle/30 font-medium' : ''
              }`}
            >
              {c.symbol} {c.code}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
